import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_outbound_order_details_report_auto_emailService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { ownerId?: number, projectId?: number, warehouseId?: number[], statusIds?: number[], fullTextSearch?: string, fromDate?: string, toDate?: string, carrierId?: number, carrierServiceId?: number, reference?: string, materialIds?: number[], dateType?: string, orderIds?: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, Order?: { Id?: number, LookupCode?: string, OwnerReference?: string, VendorReference?: string, Account?: { Id?: number, Name?: string }, OrderClass?: { Id?: number }, ShipmentOrderLookups?: { ShipmentId?: number }[], OrderLines?: { LineNumber?: number }[], Project?: { LookupCode?: string } }, Shipment?: { Id?: number, ShippedDate?: string, Carrier?: { Name?: string } }, Material?: { Description?: string, LookupCode?: string }, VendorLot?: { ExpirationDate?: string, LookupCode?: string }, Lot?: { LookupCode?: string }, ActualPackagedPack?: { Name?: string, ShortName?: string }, ActualTargetLicensePlate?: { GrossWeight?: number, NetWeight?: number } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { ownerId?: number, projectId?: number, warehouseId?: number[], statusIds?: number[], fullTextSearch?: string, fromDate?: string, toDate?: string, carrierId?: number, carrierServiceId?: number, reference?: string, materialIds?: number[], dateType?: string, orderIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, Order?: { Id?: number, LookupCode?: string, OwnerReference?: string, VendorReference?: string, Account?: { Id?: number, Name?: string }, OrderClass?: { Id?: number }, ShipmentOrderLookups?: { ShipmentId?: number }[], OrderLines?: { LineNumber?: number }[], Project?: { LookupCode?: string } }, Shipment?: { Id?: number, ShippedDate?: string, Carrier?: { Name?: string } }, Material?: { Description?: string, LookupCode?: string }, VendorLot?: { ExpirationDate?: string, LookupCode?: string }, Lot?: { LookupCode?: string }, ActualPackagedPack?: { Name?: string, ShortName?: string }, ActualTargetLicensePlate?: { GrossWeight?: number, NetWeight?: number } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { ownerId?: number, projectId?: number, warehouseId?: number[], statusIds?: number[], fullTextSearch?: string, fromDate?: string, toDate?: string, carrierId?: number, carrierServiceId?: number, reference?: string, materialIds?: number[], dateType?: string, orderIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, Order?: { Id?: number, LookupCode?: string, OwnerReference?: string, VendorReference?: string, Account?: { Id?: number, Name?: string }, OrderClass?: { Id?: number }, ShipmentOrderLookups?: { ShipmentId?: number }[], OrderLines?: { LineNumber?: number }[], Project?: { LookupCode?: string } }, Shipment?: { Id?: number, ShippedDate?: string, Carrier?: { Name?: string } }, Material?: { Description?: string, LookupCode?: string }, VendorLot?: { ExpirationDate?: string, LookupCode?: string }, Lot?: { LookupCode?: string }, ActualPackagedPack?: { Name?: string, ShortName?: string }, ActualTargetLicensePlate?: { GrossWeight?: number, NetWeight?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      ownerId?: number, projectId?: number, warehouseId?: number[], statusIds?: number[], fullTextSearch?: string, fromDate?: string, toDate?: string, carrierId?: number, carrierServiceId?: number, reference?: string, materialIds?: number[], dateType?: string, orderIds?: number[]    }) {
      return false;
    }
}
